import React, { useEffect, useState } from 'react';
import './SidePanel.css';

/**
 * A purely React-controlled Side Panel (Offcanvas).
 * Replaces MUI Drawer.
 */
export default function SidePanel({
  open,
  onClose,
  title,
  children,
  anchor = 'right', // left, right
  width = 400,
}) {
  const [showContent, setShowContent] = useState(false);

  // Handle animation sequencing
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
      // Small delay to allow CSS transitions to catch the state change
      requestAnimationFrame(() => setShowContent(true));
    } else {
      setShowContent(false);
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  // Handle Escape key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && open && onClose) {
        onClose();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [open, onClose]);

  if (!open && !showContent) return null;

  return (
    <>
      <div
        className={`xs-side-panel-backdrop ${showContent ? 'show' : ''}`}
        onClick={onClose}
        role="presentation"
      ></div>
      <div
        className={`xs-side-panel-offcanvas anchor-${anchor} ${showContent ? 'show' : ''}`}
        style={{ width: `${width}px` }}
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
      >
        {title && (
          <div className="offcanvas-header border-bottom px-4 py-3">
            <h5 className="offcanvas-title mb-0">{title}</h5>
            <button
              type="button"
              className="xs-btn-close"
              onClick={onClose}
              aria-label="Close"
            ></button>
          </div>
        )}
        <div className="offcanvas-body xs-side-panel-body-scroll p-4">{children}</div>
      </div>
    </>
  );
}
